import { render, staticRenderFns } from "./ConcernedTable.vue?vue&type=template&id=f6c08d0a&scoped=true&"
import script from "./ConcernedTable.vue?vue&type=script&lang=js&"
export * from "./ConcernedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c08d0a",
  null
  
)

export default component.exports